import { buildTraceparent } from '@link-factory/shared/BuildTraceparent';
import { generateTraceId } from '@link-factory/shared/GenerateTraceId';
import { generateSpanId } from '../observability/GenerateSpanId';

export function generateTraceparent(): { traceId: string; traceparent: string } {
  const traceId = generateTraceId();
  const traceparent = buildTraceparent(traceId, generateSpanId());
  return { traceId, traceparent };
}
